import React from 'react';
import { SwitchProps } from '@mui/material';
import * as Styled from './MBSwitch.styles';

export interface MBSwitchProps extends SwitchProps {
  checked?: boolean;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

const MBSwitch: React.FC<MBSwitchProps> = ({
  inputProps,
  color = 'default',
  ...rest
}) => {
  return (
    <Styled.SwitchWrapper>
      <Styled.StyledSwitch
        inputProps={{ ...inputProps, 'aria-label': 'Switch' }}
        color={color}
        {...rest}
      />
    </Styled.SwitchWrapper>
  );
};

export default MBSwitch;
